import React from "react";
import linkLogo from "../../assets/icons/link.svg";
import { ReactComponent as BotIcon } from "../../assets/icons/bot.svg";
import { ReactComponent as ArrowRightIcon } from "../../assets/icons/arrowRight.svg";
import { ReactComponent as ArrowLeftIcon } from "../../assets/icons/arrowLeft.svg";
import { Link } from "react-router-dom";
import { logActivity } from "../../helpers/activityLog";
import "../SupportingApp/SupportingApp.scss";
import Chatbot from "../../components/Chatbot/Chatbot";

const KnowledgeCenterLinks = [
  //   {
  //     name: "طريقة استخدام مشهد",
  //     link: "",
  //   },
  //   {
  //     name: "طريقة استخدام الداشبورد PBI",
  //     link: "",
  //   },
  /*
  {
    name: "منصة عين اليمامة",
    link: "http://Yamamah.alriyadh.gov.sa/site",
  },
  {
    name: "تطبيق عين اليمامة (ايفون)",
    link: "http://install.appcenter.ms/orgs/hockeyappsacc-zb69/apps/check-alriyadh/distribution_groups/prod",
  },
  {
    name: "تطبيق عين اليمامة (أندرويد)",
    link: "https://install.appcenter.ms/orgs/hockeyappsacc-zb69/apps/check-alriyadh-1/distribution_groups/prod",
  },
  {
    name: "نموذج طلب صلاحيات على عين اليمامة",
    link: "https://docs.google.com/spreadsheets/d/1HHVWo1N0JVEpB8LjCmBJECW-8FqkEI3n/edit?usp=sharing&ouid=104413127309405166161&rtpof=true&sd=true",
  },
  {
    name: "طريقة إنشاء نشاط في عين اليمامة",
    link: "https://drive.google.com/file/d/1FL0CWlNe_0uwLddzbdgZIrN_DKlmsMSx/view?usp=sharing",
  },
  {
    name: "الدليل الإرشادي",
    link: "https://drive.google.com/file/d/1-GRPoHuivlRZ8FiG6hN2_wwXHmshkZOu/view?usp=sharing",
  },
  {
    name: "فيديوهات لعين اليمامة",
    link: "https://drive.google.com/drive/folders/1dkWF7h_ix3IGea4hUyLjtObCzdeMr7K7",
  },
  */
  {
    name: "SLA",
    link: "https://docs.google.com/spreadsheets/d/1v1c2slnHciA9J-nBkZoUsSU_-Oja5mc1/edit?usp=sharing&ouid=104413127309405166161&rtpof=true&sd=true",
  },
  {
    name: "Guideline",
    link: "https://drive.google.com/file/d/1oAwBMoYj6kL1kSYEk7NbVnAY_-SUpv2Z/view",
  },
  {
    name: "رابط المنصة",
    link: "https://yamamah.alriyadh.gov.sa/Site/",
  },
  {
    name: "انشاء نشاط",
    link: "https://yamamah.alriyadh.gov.sa/Site/",
  },
  {
    name: "نموذج طلب صلاحية",
    link: "https://docs.google.com/spreadsheets/d/1HHVWo1N0JVEpB8LjCmBJECW-8FqkEI3n/edit?usp=sharing&ouid=104413127309405166161&rtpof=true&sd=true",
  },
  {
    name: "رابط تطبق الاندرويد",
    link: "https://install.appcenter.ms/orgs/hockeyappsacc-zb69/apps/check-alriyadh-1/distribution_groups/prod",
  },
  {
    name: "رابط تطبيق الايفون",
    link: "https://install.appcenter.ms/orgs/hockeyappsacc-zb69/apps/check-alriyadh/distribution_groups/prod",
  },
];

const KnowledgeCenter = () => {
  return (
    <div className="SupportingApp">
      <Chatbot />
      <div className="left"></div>
      <div className="right">
        <Link to="/">
          <ArrowLeftIcon className="back" title="Back" />
        </Link>
        <h1>Knowledge Center</h1>

        <div className="apps">
          {KnowledgeCenterLinks.map((i) => (
            <a
              key={i.name}
              href={i.link}
              className="app"
              onClick={() =>
                logActivity({
                  eventType: "Click",
                  eventCategory: "Knowledge Center",
                  eventDescription: `Opened ${i.name} from Landing Page`,
                  moduleName: i.name,
                  metadata: JSON.stringify({ url: i.link }),
                })
              }
            >
              <div className="app_img">
                <img src={linkLogo} alt="Mashhad Logo" />
              </div>
              <div className="app_content">
                <h5>{i.name}</h5>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KnowledgeCenter;
